import { NgIf } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-password-check',
  templateUrl: './password-check.component.html',
  styleUrls: ['./password-check.component.scss'],
  standalone: true,
  imports: [MatIconModule, NgIf]
})
export class PasswordCheckComponent implements OnInit, OnDestroy {
  @Input() passwordFormField: FormControl;

  sub = new Subscription();

  passwordLengthOk = false;
  passwordComplexityOk = false;

  ngOnInit(): void {
    this.sub = this.passwordFormField.valueChanges.subscribe((v: string) => {
      this.passwordLengthOk = v.length >= 8;
      this.passwordComplexityOk = v.match('^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).+$') ? true : false;
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
